import React, { useCallback, useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
// import { Text } from 'rebass'

import styled from 'styled-components'
import Settings from '../Settings'
import useHtPrice from '../../hooks/useHtPrice'
import LngSwithForWeb from './LngSwithForWeb'
import Nav from './Nav'
import { useIsDarkMode } from '../../state/user/hooks'
import Logo from './Logo'
import menuIcon from '../../assets/images/menu.png'
import MobileMenu from '../MobileMenu'
import AccountButton from './AccountButton'
import Web3Status from '../Web3Status'
import { NetworkButton } from './NetworkButton'
import CoyIcon from '../../assets/images/coy_logo.png'
import { SwapPoolTabs } from '../NavigationTabs'
import { useLocation } from 'react-router-dom'
import { isNewPage } from '../../utils'

const HeaderFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  top: 0;
  position: absolute;
  background:  ${({ theme }) => theme.colors.bg1}
  z-index: 2;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    width: calc(100%);
    position: relative;
  `};
`
const Menu = styled.div`
  display: none;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    display: block;
    width: 30px;
    margin-right: 10px;
    img {
      width: 100%;
      display: block;
    }
  `};
`
const HeaderElement = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 320px) {
    width: 20%;
  }
`

const HeaderControlsMobile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const Title = styled.a`
  display: flex;
  align-items: center;
  pointer-events: auto;
  text-decoration: none;
  :hover {
    cursor: pointer;
  }
`

const HeaderControls = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ theme }) => theme.mediaWidth.upToSmall`
  `};
`

const StyledTopBarInner = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
  padding: 10px 24px;
  @media (max-width: 850px) {
    min-width: auto;
  }
`
const StyledAccountButtonWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  ${({ theme }) => theme.mediaWidth.upToExtraSmall`
    .lng-switch, .price {
      display: none;
    }
  `};
`

const Price = styled.div`
  color: ${props => props.theme.colors.primary};
  margin-right: 24px;
  font-weight: bolder;
`

export default function Header() {
  const isDark = useIsDarkMode()
  const { pippiPrice } = useHtPrice()
  const [mobileMenu, setMobileMenu] = useState(false)
  const handlePresentMobileMenu = useCallback(() => {
    setMobileMenu(true)
  }, [setMobileMenu])
  const handleDismissMobileMenu = useCallback(() => {
    setMobileMenu(false)
  }, [setMobileMenu])

  const location = useLocation()  
  if (isNewPage(location.pathname)) {
    return null
  }

  return (
    <HeaderFrame>
      <StyledTopBarInner>
        {!isMobile && <HeaderElement>
          <Menu onClick={handlePresentMobileMenu}>
            <img style={{ borderRadius: '50%' }} src={menuIcon} alt="menu" />
          </Menu>
          {/* <Title href="https://www.alchemistswap.finance/"> */}
          <Title>
            <Logo isDark={isDark} />
          </Title>
          {!isMobile && <Nav />}
        </HeaderElement>}
        {isMobile && <HeaderElement>
          <Menu onClick={() => { }}>
            <img style={{ borderRadius: '50%' }} src={CoyIcon} alt="menu" />
          </Menu>
        </HeaderElement>}
        {isMobile && (
          <HeaderControlsMobile>
            <Web3Status />
            <LngSwithForWeb />
            <Settings />
            <AccountButton />
          </HeaderControlsMobile>
        )}
        {!isMobile && (
          <HeaderControls>
            <HeaderElement>
              <StyledAccountButtonWrapper>
                <Web3Status />
                <NetworkButton />
                <div style={{ width: 10 }}></div>
                {/* <Price className="number price">1AG=${pippiPrice.toFixed(3)}</Price> */}
                <LngSwithForWeb />
                <Settings />
                <AccountButton />
              </StyledAccountButtonWrapper>
            </HeaderElement>
          </HeaderControls>
        )}
        <MobileMenu onDismiss={handleDismissMobileMenu} visible={mobileMenu} />
      </StyledTopBarInner>
      {<div style={{
        display: 'flex',
        justifyContent: isMobile ? 'flex-start' : 'center',
        width: '100vw',
        height: '49px',
        paddingLeft: isMobile ? '16px' : '0',
        background: 'rgb(33, 52, 62)',
        borderTop: '1px solid rgb(48, 213, 193)'
      }}>
        <SwapPoolTabs active={'swap'} />
      </div>}
    </HeaderFrame>
  )
}
